import { FormControl, InputLabel, TextField } from "@mui/material"

const BaseTextField = (props) => {
  const { id, _label } = props

  return (
    <FormControl fullWidth sx={{ mt: 2 }}>
      <InputLabel
        shrink
        htmlFor={id}
        variant="subtitle1"
        sx={{
          position: "static",
        }}
      >
        {_label}
      </InputLabel>

      <TextField
        id={id}
        variant="outlined"
        name={id}
        {...props}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            backgroundColor: "white",
            height: 50,
            fontWeight: 400,
          },
        }}
      />
    </FormControl>
  )
}

export default BaseTextField
